import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Headers } from '@angular/http';

import { MainService } from 'app/resources/services/index';
import { DefineBootboxId, EnderecoResidencial } from 'app/resources/classes';

@Component({
  selector: 'app-loja-carrinho',
  templateUrl: './loja-carrinho.component.html'
})
export class LojaCarrinhoComponent implements OnInit {

  public pedidos: any;
  public cartao: any;
  public processando: boolean;
  public freteOpcoes: Array<any> = [];
  public opcaoFrete: any;
  public senhaEletronica: string;
  public cep: string;
  public logradouroIsReadOnly: boolean;
  public bairroIsReadOnly: boolean;
  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();

  constructor(public mainService: MainService, public router: Router) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.processando = true;
    this.logradouroIsReadOnly = true;
    this.bairroIsReadOnly = true;
    this.cep = '';
    this.processando = false;

    this.mainService.http.pathRest().get('cartao/current/', true)
      .subscribe(
        sucesso => {
          this.cartao = sucesso.json();
          if (this.isPessoaFisica()) {
            this.mainService.lojaCarrinho.destinatario.nome = this.cartao.nome;
            this.mainService.lojaCarrinho.destinatario.documento = this.cartao.documento;
            this.mainService.lojaCarrinho.destinatario.email = this.cartao.emailInicial;
            let _tel = '';
            if (this.cartao.telefoneResidencial.numero) {
              _tel = '(' + this.cartao.telefoneResidencial.ddd + ') ' + this.cartao.telefoneResidencial.numero;
            } else if (this.cartao.telefoneCelular.numero) {
              _tel = '(' + this.cartao.telefoneCelular.ddd + ') ' + this.cartao.telefoneCelular.numero;
            } else if (this.cartao.telefoneComercial.numero) {
              _tel = '(' + this.cartao.telefoneComercial.ddd + ') ' + this.cartao.telefoneComercial.numero;
            }
            this.mainService.lojaCarrinho.destinatario.telefone = _tel;
          } else {
            this.mainService.lojaCarrinho.destinatario.nome = undefined;
            this.mainService.lojaCarrinho.destinatario.documento = undefined;
            this.mainService.lojaCarrinho.destinatario.email = undefined;
            this.mainService.lojaCarrinho.destinatario.telefone = undefined;
          }
        });

    this.mainService.http.pathRest().get('loja/pedidos/', true)
      .subscribe(
        sucesso => {
          this.pedidos = sucesso.json();
          this.processando = false;
        }, erro => {
          this.processando = false;
        });

    this.mainService.saldoService.initialize();
    this.processando = false;
  }

  public limparCarrinho() {
    const that = this;
    if (this.mainService.lojaCarrinho.totalItens() >= 1) {
      const mensagem = bootbox.confirm({
        message: 'Deseja remover todos os produtos do carrinho?',
        buttons: {
          confirm: {
            label: 'Sim',
            className: 'btn-danger'
          },
          cancel: {
            label: 'Não',
            className: 'app-btn-best'
          }
        },
        callback: function (result) {
          if (result) {
            that.mainService.lojaCarrinho.clean();
            that.limparFrete();
          }
        }
      });
      mensagem.on('shown.bs.modal', function () {
        $('button[data-bb-handler="cancel"]').attr('id', 'btn-bootbox-cancel');
        $('button[data-bb-handler="confirm"]').attr('id', 'btn-bootbox-confirm');
        $('button[class="bootbox-close-button close"]').attr('id', 'btn-bootbox-close');
        $('div[class="bootbox-body"]').attr('id', 'div-bootbox-body');
      });
    }
  }

  public limparFrete() {
    if (this.cep === undefined || this.cep === '') {
      this.freteOpcoes = [];
      this.opcaoFrete = undefined;
      this.mainService.lojaCarrinho.enderecoEntrega = undefined;
      this.senhaEletronica = undefined;
    }
  }

  public removerItemCarrinho(p) {
    const that = this;
    if (this.mainService.lojaCarrinho.totalItens() <= 1) {
      const mensagem = bootbox.confirm({
        message: 'Apagando este item seu carrinho ficara vazio. Deseja apagar mesmo assim?',
        buttons: {
          confirm: {
            label: 'Sim',
            className: 'btn-danger'
          },
          cancel: {
            label: 'Não',
            className: 'app-btn-best'
          }
        },
        callback: function (result) {
          if (result) {
            that.mainService.lojaCarrinho.remove(p);
          }
        }
      });
      mensagem.on('shown.bs.modal', function () {
        $('button[data-bb-handler="cancel"]').attr('id', 'btn-bootbox-cancel');
        $('button[data-bb-handler="confirm"]').attr('id', 'btn-bootbox-confirm');
        $('button[class="bootbox-close-button close"]').attr('id', 'btn-bootbox-close');
        $('div[class="bootbox-body"]').attr('id', 'div-bootbox-body');
      });
    } else {
      this.mainService.lojaCarrinho.remove(p);
    }
  }

  public calcularFrete() {
    this.processando = true;
    this.freteOpcoes = [];
    this.opcaoFrete = undefined;
    this.mainService.lojaCarrinho.enderecoEntrega = undefined;
    this.mainService.cepService.findByViaCep(this.cep)
      .subscribe(
        sucesso => {
          sucesso = sucesso.json();

          this.mainService.lojaCarrinho.enderecoEntrega = new EnderecoResidencial({
            bairro: sucesso.bairro,
            cep: this.cep,
            cidade: sucesso.localidade,
            logradouro: sucesso.logradouro,
            numero: '',
            uf: sucesso.uf,
            complemento: ''
          });

          this.logradouroIsReadOnly = !this.mainService.lojaCarrinho.enderecoEntrega ||
            !this.mainService.lojaCarrinho.enderecoEntrega.cidade ||
            this.mainService.lojaCarrinho.enderecoEntrega.logradouro;

          this.bairroIsReadOnly = !this.mainService.lojaCarrinho.enderecoEntrega ||
            !this.mainService.lojaCarrinho.enderecoEntrega.cidade ||
            this.mainService.lojaCarrinho.enderecoEntrega.bairro;

          this.mainService.http.pathRest().post('loja/pedidos/frete/',
            this.mainService.lojaCarrinho, true)
            .subscribe(
              data => {
                this.freteOpcoes = data.json();
                this.processando = false;
              }, erro => {
                this.processando = false;
                this.bootboxAlertComId.alerta(erro._body);
              });
        }, erro => {
          this.processando = false;
        });
  }

  public isPessoaFisica() {
    return this.mainService.cartaoService.isPessoaFisica(this.cartao.documento);
  }

  public totalPontos() {
    if (!this.opcaoFrete) {
      return this.mainService.lojaCarrinho.totalPontos();
    } else {
      return this.mainService.lojaCarrinho.totalPontos() + this.opcaoFrete.frete.pontos;
    }
  }

  setFrete(opcao) {
    this.opcaoFrete = opcao;
  }

  public save() {
    if (!this.mainService.lojaCarrinho.destinatario.nome) {
      this.bootboxAlertComId.alerta('Digite o Nome do destinatário');
    } else if (!this.mainService.lojaCarrinho.destinatario.documento) {
      this.bootboxAlertComId.alerta('Digite o número de CPF do destinatário');
    } else if (!this.mainService.lojaCarrinho.destinatario.email) {
      this.bootboxAlertComId.alerta('Digite o endereço de email do destinatário');
    } else if (!this.mainService.lojaCarrinho.destinatario.telefone) {
      this.bootboxAlertComId.alerta('Digite o telefone do destinatário');
    } else if (!this.senhaEletronica) {
      this.bootboxAlertComId.alerta('Digite a senha eletrônica.');
    } else {
      this.processando = true;
      this.mainService.lojaCarrinho.frete = this.opcaoFrete.frete;

      const cabecalho: Headers = new Headers();
      cabecalho.append('Authorization', 'Basic ' + this.mainService.sessionService.getAuthBasic());
      cabecalho.append('X-Auth-Ep', this.senhaEletronica);

      this.mainService.http.pathRest().post('loja/pedidos/', this.mainService.lojaCarrinho, true, cabecalho)
        .subscribe(
          sucesso => {
            this.mainService.lojaCarrinho.clean();
            this.limparFrete();
            this.processando = false;
            this.mainService.saldoService.initialize();
            this.router.navigate(['/loja']);
            this.bootboxAlertComId.alerta('O pedido na loja foi realizado com sucesso!');
          }, erro => {
            this.processando = false;
            this.bootboxAlertComId.alerta(erro._body);
          });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/loja/loja-carrinho/loja-carrinho.component.ts